/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Get_Listed_Dialog_Message_Text_Community_MemberInputs */



/**
* | output |
* | --- |
* | "We need [name of the chain] listed on Chainspect! It’s where 50+ chains track metrics like TPS, decentralization, and traction. Would be awesome to see our s..." |
*
* @param {Get_Listed_Dialog_Message_Text_Community_MemberInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const get_listed_dialog_message_text_community_member = /** @type {((inputs?: Get_Listed_Dialog_Message_Text_Community_MemberInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Get_Listed_Dialog_Message_Text_Community_MemberInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("We need [name of the chain] listed on Chainspect! It’s where 50+ chains track metrics like TPS, decentralization, and traction. Would be awesome to see our stats there")
});